import { PATH } from './path-routes';

/**
 * Экраны мобильных приложений, где внизу остаются юридические ссылки (оферта, политика и т.д.):
 * вход, регистрация, восстановление пароля и сами документы. В остальных разделах ссылки
 * собраны в профиле, чтобы не превращать приложение в сайт.
 */
const LEGAL_FOOTER_PATHS: readonly string[] = [
  PATH.signIn,
  PATH.register,
  PATH.forgotPassword,
  PATH.resetPassword,
  PATH.trainerSignIn,
  '/legal'
];

export function isMobileLegalFooterPath(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, '') || '/';
  return LEGAL_FOOTER_PATHS.some((base) => p === base || p.startsWith(`${base}/`));
}
